<template>
    <DppButtonPresentational
        :isActive = dpp.isActive
        :isMobile = glb.isMobile
        :isFavorite = isFavorite
        :photoCount = dpp.photoCount
        :savedHomesCount = getSavedHomesCount
        :mapPinText = "molang('dpp.propertyButton.map')"
        :shareText = "molang('dpp.propertyButton.share')"
        :editText = "molang('dpp.propertyButton.edit')"
        :favoriteText = "isFavorite ? molang('dpp.propertyButton.saved') : molang('dpp.propertyButton.save')"
        :onPhotoViewClicked = popPhotoView
        :onMapViewClicked = popMapView
        :onEditClicked = popContactUs
        :onShareViewClicked = sendEmail
        :onFavoriteClicked = favoriteAction
    />
</template>
<script src="./dpp-button.js"></script>
